module.exports = __webpack_public_path__ + "img/maintenanceIcon.e232e800.svg";